import {FunctionComponent} from "react";
import {Button, Container, Grid, Typography} from "@mui/material";
import {documentToReactComponents} from "@contentful/rich-text-react-renderer";
import {ImageAsset, Link} from "../../types";
import {Document} from "@contentful/rich-text-types";
import styled from "styled-components";
import ChequeredStrip from "../blockComponents/ChequeredStrip";

interface Props {
    hero: {
        featureImage: ImageAsset;
        title: string;
        content: Document;
        callToAction: Link;
    };
}

const StyledContainer = styled(Container)`
    z-index: 2;
    font-size: 1rem;

    img {
        margin-top: -150px;
        margin-bottom: -6px;
    }
`;
const Wrapper = styled.div`
    width: 100%;
`;
const TitleWrapper = styled.div`
    width: 100%;
    background-color: #f0f0f0;
    height: 160px;
    display: flex;
    align-items: center;

    h1 {
        margin: 0;
    }

    span {
        p {
            margin: 0;
            font-size: 1.3em;
        }
    }
`;
const StyledButton = styled(Button)`
    &.MuiButton-root {
        border-color: #de4a22;
    }
`;
const Hero: FunctionComponent<Props> = ({
        hero: {featureImage, title, content, callToAction},
    }) => {
    const hero = featureImage
        ? {
            image: featureImage.fields.file.url,
            imageText: featureImage.fields.title,
        }
        : {};
    const description = content ? documentToReactComponents(content) : "";
    const linkText = callToAction ? callToAction.fields.linkTitle : "";
    const linkHoverText = callToAction ? callToAction.fields.linkHoverText : "";
    const linkUrl = callToAction ? callToAction.fields.linkUrl : "";
    return (
        <Wrapper>
            <TitleWrapper>
                <ChequeredStrip location="top"/>
                <Container maxWidth="lg">
                    <Typography component="h1" variant="h1" color="inherit" gutterBottom>
                        {title}
                    </Typography>
                    {!featureImage && (
                        <Typography
                            component="span"
                            variant="subtitle1"
                            color="inherit"
                            gutterBottom
                        >
                            {description}
                        </Typography>
                    )}
                </Container>
            </TitleWrapper>
            <StyledContainer maxWidth="lg">
                {featureImage && (
                    <Grid container alignItems="center" justifyContent="center">
                        <Grid item sm={6}>
                            <div>{description}</div>
                            {callToAction && (
                                <Button variant="contained" color="primary" href={linkUrl}>
                                    {linkText}
                                </Button>
                            )}
                        </Grid>
                        <Grid item sm={2}/>
                        <Grid item sm={4} sx={{display: {smDown: `none`}}}>
                            <picture>
                                <source
                                    type="image/webp"
                                    srcSet={`${hero.image}?fm=webp&w=400&q=90`}
                                    media="(max-width: 400px)"
                                />
                                <source
                                    type="image/webp"
                                    srcSet={`${hero.image}?fm=webp&q=80`}
                                    media="(min-width: 401px)"
                                />
                                <source
                                    type="image/jpeg"
                                    srcSet={`${hero.image}?w=400&q=80`}
                                    media="(max-width: 400px)"
                                />
                                <source
                                    type="image/jpeg"
                                    srcSet={`${hero.image}?q=80`}
                                    media="(min-width: 401px)"
                                />
                                <img src={`${hero.image}?q=90`} alt={hero.imageText}/>
                            </picture>
                        </Grid>
                    </Grid>
                )}
            </StyledContainer>
        </Wrapper>
    );
};
export default Hero;
